import{createStyles as e}from"../../../../theme/utils/create-styles.js";var r=e({root:{overflow:"hidden"},overlayWrapper:{position:"relative"}});export{r as styles};
